const CheckAllIcon = props => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="#9AA5A5"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15 1.5H6C5.175 1.5 4.5 2.175 4.5 3V12C4.5 12.825 5.175 13.5 6 13.5H15C15.825 13.5 16.5 12.825 16.5 12V3C16.5 2.175 15.825 1.5 15 1.5ZM9.3525 10.5L6.75 7.875L7.8 6.8175L9.3525 8.3775L13.2 4.5L14.25 5.5575L9.3525 10.5ZM3 4.5H1.5V15C1.5 15.825 2.175 16.5 3 16.5H13.5V15H3V4.5Z" />
  </svg>
)

export default CheckAllIcon
